module.exports = __webpack_public_path__ + "h5/img/shoutu@2x.4043ba8c.png";